module.exports = __webpack_public_path__ + "img/nav3.4754fd5c.png";